module.exports = __webpack_public_path__ + "images/map-pin--aa5009f1cc4200f13d57fe44e2dc55e6.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__pol/components/provider-search/map/images/map-pin.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--10-0!/tool/node_modules/img-loader/index.js??ref--10-1!/tool/project/client/src/site__pol/components/provider-search/map/images/map-pin.svg
// module chunks = site__pol